export default __webpack_public_path__ + "assets/images/aistudio/empty_state/fa00900c4b76e6c2a986db6e56e716fa.png";